export * from './creditInstitutionList';
export * from './houseLoanTypes';
export * from './yearList';
export const DEFAULT_PENSION_AGE = 69;
export const DEFAULT_MAX_DKK_VALUE = 1_000_000_000;
export const DEFAULT_HOUSE_DEBT_INTEREST = 0.03; // Default interest on the house debt
export const DEFAULT_CONTRIBUTION_RATE = 0.007; // value provided by Lone - 0.7%
export const DEFAULT_SPOUSE_PAYMENT_PERCENTAGE = 6;
export const DEFAULT_USER_AGE = 40; // Default age of user, agreed with Lone (4. jan 2023)
